import { lazy } from 'react';

export const LazyCropImage = lazy(() => import('./CropImage'));
